import React, { useEffect, useState } from 'react';
import { Box, Inscription, SearchInput, SelectDropdown, useDebounce } from '@common-fe/common-fe';

import { OptionKey } from '@/common/types';

import { ALL_SERVICE_TYPES_KEY, SERVICE_TYPE_FILTER_OPTIONS } from '../../../Services.constants';

const SEARCH_DEBOUNCE_MS = 300;

interface ServicesListControlsProps {
  total: number;
  searchString: string;
  serviceTypeFilter: string;
  onSearchChange: (value: string) => void;
  onServiceTypeChange: (value: string) => void;
}

const ServicesListControls: React.FC<ServicesListControlsProps> = ({
  total,
  searchString,
  serviceTypeFilter,
  onSearchChange,
  onServiceTypeChange,
}) => {
  const [localSearch, setLocalSearch] = useState(searchString);
  const debouncedSearch = useDebounce(localSearch, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    onSearchChange(debouncedSearch);
  }, [debouncedSearch, onSearchChange]);

  useEffect(() => {
    setLocalSearch(searchString);
  }, [searchString]);

  const handleServiceTypeChange = (value: OptionKey) => {
    onServiceTypeChange((value as string) || ALL_SERVICE_TYPES_KEY);
  };

  return (
    <Box direction="row" justify="between" align="center" pad={{ bottom: 'spacing16' }}>
      <Inscription weight="bold" color="textBody" lineHeight="20px">
        Services: {total}
      </Inscription>
      <Box direction="row" gap="spacing12">
        <Box width="230px">
          <SearchInput
            hasSearchingHistory
            className="search-input"
            testId="services-list_search"
            value={localSearch}
            placeholder="Search"
            onChange={setLocalSearch}
          />
        </Box>
        <Box width="230px">
          <SelectDropdown
            id="serviceType"
            singleMode
            testId="services-list_type-filter"
            ellipsisMode
            activeTitle
            name="Type"
            prefix="Type"
            options={SERVICE_TYPE_FILTER_OPTIONS}
            value={serviceTypeFilter}
            onChange={handleServiceTypeChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ServicesListControls;
